import { render, staticRenderFns } from "./AltCheckbox.vue?vue&type=template&id=08fbf3fe&"
import script from "./AltCheckbox.vue?vue&type=script&lang=js&"
export * from "./AltCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AltCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports